import type {
  IGlobalSrs,
  ICoords,
  TranslationMatrix,
} from "./types";

// @ts-ignore
import * as proj4 from "proj4";

export function convertAssumedToGlobal(
  matrix: TranslationMatrix,
  assumedCoords: ICoords,
): ICoords {
  // As in Office app:
  // const [a1, b1, c1, a2, b2, c2] = site.assumedCS.toEPSGTranslationMatrix;
  // const xEPSG = x * a1 + y * b1 + c1;
  // const yEPSG = x * a2 + y * b2 + c2;
  const xEPSG =
    assumedCoords.x * matrix[0] + assumedCoords.y * matrix[1] + matrix[2];
  const yEPSG =
    assumedCoords.x * matrix[3] + assumedCoords.y * matrix[4] + matrix[5];
  const result: ICoords = {
    x: xEPSG,
    y: yEPSG,
    z: assumedCoords.z,
  };
  return result;
}

export function convertGlobalToAssumed(
  matrix: TranslationMatrix,
  globalCoords: ICoords,
): ICoords {
  const [a1, b1, c1, a2, b2, c2] = matrix;
  const { x, y } = globalCoords;
  //
  // backward translation from 3857 to local:
  // y = ( a1*(c2-yw) + a2*(xw-c1) ) / (a2*b1-a1*b2)
  // x = (xw-b1*y-c1) / a1
  // where xw, yw - coordinates in 3857
  //
  const yLocal = (a1 * (c2 - y) + a2 * (x - c1)) / (a2 * b1 - a1 * b2);
  const xLocal = (x - b1 * yLocal - c1) / a1;
  return {
    x: xLocal,
    y: yLocal,
    z: globalCoords.z,
  };
}

export function convertGlobalToWgs84(
  proj4def: string,
  globalCoords: ICoords,
): ICoords {
  return proj4Convert(proj4def, WGS84().proj4, globalCoords);
}

export function convertWgs84ToGlobal(
  proj4def: string,
  wgs84Coords: ICoords,
): ICoords {
  return proj4Convert(WGS84().proj4, proj4def, wgs84Coords);
}

export function WGS84(): IGlobalSrs {
  return {
    epsg: "EPSG:4326",
    proj4: "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs ",
  };
}

function proj4Convert(projA: any, projB: any, coords: ICoords): ICoords {
  // HACK: fix import for proj4
  const func = proj4.default || proj4;
  // Proj4 mutates original argument when working with EPSG:32652
  // see https://app.asana.com/0/202757487441645/1117035985023638
  const coordsCopy = { ...coords };

  // Keep elevation
  const result: ICoords = func(projA, projB, coordsCopy);
  return {
    x: result.x,
    y: result.y,
    z: coords.z,
  };
}
